<template>
  <div class="understanding-block">
    <div class="title-bar">UNDERSTANDING</div>
    <div class="input-bar">
      <div class="input-group">
        <div class="form-group-feedback">
          <input
            type="text"
            class="form-control form-control-sm alpha-grey"
            placeholder="Enter message"
            v-model="messageInput"
            @keyup.enter="authenticClick"
          />
        </div>
        <div class="input-group-append">
          <button type="submit" class="btn bg-orange btn-sm" @click="authenticClick">Test</button>
        </div>
      </div>
    </div>
    <div class="content-wrapper">
      <FadeTransition :duration="500">
        <div v-if="predicting" class="loading-card">
          <em class="fas fa-circle-notch fa-spin"></em>
          <span>Loading...</span>
        </div>
      </FadeTransition>
      <SlideYUpTransition group>
        <div
          class="result-model-card"
          v-for="modelResult in predictedResult"
          :key="modelResult.modelId"
          @click="toggleResult(modelResult)"
        >
          <div class="result-card-title">
            <div>
              {{modelResult.modelName}}
              <em
                v-if="modelResult.predicted"
                class="fa fa-check result-found-icon"
                title="Got this result for sure"
              ></em>
              <em
                v-if="modelResult.toBeTrained"
                class="fa fa-exclamation-triangle text-orange-300"
                title="Word found in to be train list, please train and recheck."
              ></em>
            </div>
            <div>
              <em v-if="modelResult.open" class="fas fa-angle-down"></em>
              <em v-else-if="!modelResult.open" class="fas fa-angle-right"></em>
            </div>
          </div>
          <CollapseTransition :styles="{animationTimingFunction: 'ease-in'}">
            <div class="result-block-data"
                 v-if="modelResult.open && modelResult.data &&
                 modelResult.data[0] && modelResult.data[0].predictionProbability">
              <div
                class="result-block-data-row"
                v-for="prob in modelResult.data[0].predictionProbability"
                :key="prob.categoryName"
              >
                <div class="category-name">{{prob.categoryName}}</div>
                <div class="row">
                  <div class="col progress-block">
                    <div class="progress-text" :style="getWidthStyle(prob.probability)">
                      <span>{{toPercentString(prob.probability)}}</span>
                    </div>
                    <progress
                      class="progress is-small is-success"
                      :value="prob.probability"
                      max="1"
                    ></progress>
                  </div>
                </div>
              </div>
            </div>
            <div class="result-block-data" v-else-if="modelResult.open">
              <div class="result-block-data-row">
                <div class="category-name">No valid result to show.</div>
              </div>
            </div>
          </CollapseTransition>
        </div>
        <div
          class="result-rulebase-card"
          v-for="rulebaseResult in matchedResult"
          :key="rulebaseResult.setId"
          @click="toggleResult(rulebaseResult)"
        >
          <div class="result-card-title">
            <div>
              <span class="text-muted">Rule Set:</span>
              {{rulebaseResult.setName}}
              <em
                v-if="rulebaseResult.matched"
                class="fa fa-check result-found-icon"
                title="Got this result for sure"
              ></em>
            </div>
            <div>
              <em v-if="rulebaseResult.open" class="fas fa-angle-down"></em>
              <em v-else-if="!rulebaseResult.open" class="fas fa-angle-right"></em>
            </div>
          </div>
          <CollapseTransition :styles="{animationTimingFunction: 'ease-in'}">
            <div class="result-block-data" v-if="rulebaseResult.open">
              <div
                class="result-block-rule"
                v-for="ruleObj in rulebaseResult.data"
                :key="ruleObj.id"
              >
                <div class="text-muted font-size-sm">{{ruleObj.name}}</div>
                <div class="text-success font-weight-semibold">{{ruleObj.score | si_number}}pt</div>
              </div>
              <div
                class="result-block-rule"
                v-if="rulebaseResult.data && rulebaseResult.data.length === 0"
              >
                <div class="text-muted font-size-sm">Zero rule matched.</div>
              </div>
            </div>
          </CollapseTransition>
        </div>
        <div class="not-understand-card" v-if="isNotUnderstand" :key="'not-understand-card'">
          <img src="../../assets/images/bot_not_understand_bg.jpg"
               alt="in conclusion, bot is not understand" />
          <h3 class="mt-2 mb-0">Whoops!!!</h3>
          <div class="text-secondary">not undertanding</div>
        </div>
      </SlideYUpTransition>
    </div>
    <div class="footer-bar">
<!--      <button-->
<!--        type="button"-->
<!--        class="btn btn-sm btn-primary w-100"-->
<!--        :disabled="predicting || !predicted"-->
<!--        @click="addToLearningList"-->
<!--      >Add to learning list</button>-->
    </div>
  </div>
</template>
<script>
import Vue from 'vue';
import { mapGetters, mapActions } from 'vuex';
import { CollapseTransition, SlideYUpTransition, FadeTransition } from 'vue2-transitions';

export default {
  name: 'learning-v1-understanding-block',
  components: {
    CollapseTransition,
    SlideYUpTransition,
    FadeTransition,
  },
  props: {
    modelList: {
      type: Array,
      default: () => [],
    },
    ruleSet: {
      type: Array,
      default: () => [],
    },
    selectedMessage: String,
  },
  watch: {
    selectedMessage: {
      handler: 'updateMessage',
      immediate: true,
    },
  },
  data() {
    return {
      messageInput: '',
      predictedResult: [],
      statusResult: [],
      matchedResult: [],
      predicting: false,
      predicted: false,
      hasModelResult: false,
      hasRuleResult: false,
    };
  },
  mounted() {},
  methods: {
    ...mapActions({
      predict: 'understanding/predict',
      checkMessageStatus: 'understanding/checkMessageStatus',
      matchRuleBase: 'rulebase/matchRuleBase',
      createIssue: 'issues/createIssue',
    }),
    updateMessage() {
      if (this.messageInput !== this.selectedMessage) {
        this.messageInput = this.selectedMessage;
        this.getPredictResult();
      }
    },
    authenticClick() {
      this.getPredictResult();
      this.$emit('testClicked', null, this.messageInput);
    },
    getPredictResult() {
      this.predicting = true;
      this.predicted = false;
      this.hasModelResult = false;
      this.hasRuleResult = false;
      const text = this.messageInput.trim();
      const promiseArr = [];
      const ruleBaseArr = [];
      const statusPromiseArr = [];
      this.predictedResult = [];
      this.modelIDList.forEach((modelId) => {
        const modelName = this.modelNameIDMap[modelId] || '';
        const predictPromise = this.predict({ modelId, modelName, text });
        promiseArr.push(predictPromise);
        const statusPromise = this.checkMessageStatus({ modelId, message: text });
        statusPromiseArr.push(statusPromise);
      });
      this.ruleSetIdList.forEach((setId) => {
        const setName = this.ruleSetNameIDMap[setId];
        const matchPromise = this.matchRuleBase({
          setId, text, parent: '', setName,
        });
        ruleBaseArr.push(matchPromise);
      });
      Promise.all(statusPromiseArr)
        .then((statusData) => {
          this.statusResult = statusData;
          this.statusMap = new Map();
          statusData.forEach((sd) => {
            if (sd.status[sd.modelId]) {
              this.statusMap.set(sd.modelId, sd.status[sd.modelId]);
            }
          });
          Promise.all(promiseArr)
            .then((data) => {
              // Limit to 5 probability per each model but include category with status first
              data.forEach((d) => {
                // console.log('D', d);
                const newData = d;
                newData.open = false;
                let statusObj = null;
                if (this.statusMap.has(d.modelId)) {
                  statusObj = this.statusMap.get(d.modelId);
                  // console.log('SO', statusObj);
                }
                const dataZero = (d.data && d.data[0]) || {};
                if (dataZero && dataZero.predictionProbability) {
                  // If had status extract it from prob list
                  const extracted = [];
                  const srcArr = dataZero.predictionProbability;
                  let newArr = [];
                  if (statusObj && statusObj.categoryId) {
                    for (let i = 0; i < srcArr.length; i += 1) {
                      if (srcArr[i].categoryId === statusObj.categoryId) {
                        extracted.push(srcArr[i]);
                      } else {
                        newArr.push(srcArr[i]);
                      }
                    }
                  } else {
                    newArr = srcArr;
                  }
                  // console.log(extracted, newArr);
                  newArr.sort((a, b) => b.probability - a.probability);
                  // console.log('Sorted', newArr);
                  if (extracted.length > 0) {
                    const finalArr = extracted.concat(newArr);
                    const sliced = finalArr.slice(0, 5);
                    dataZero.predictionProbability = sliced;
                    // Found result - open for sure
                    if (statusObj && statusObj.status === 'TO_BE_TRAIN') {
                      newData.toBeTrained = true;
                    }
                    // else if (statusObj && statusObj.status === 'NEW') {
                    //   console.log('GOT NEW', newData);
                    // } else {
                    //   console.log('OTHER STAT', statusObj.status);
                    //   newData.toBeTrained = false;
                    //   newData.predicted = true;
                    //   newData.open = true;
                    //   this.hasModelResult = true;
                    // }
                  } else {
                    const sliced = newArr.slice(0, 5);
                    dataZero.predictionProbability = sliced;
                    // Open if max Prop > 50
                    // if (sliced && sliced[0] && sliced[0].probability > 0.5) {
                    //   newData.open = true;
                    // }
                  }
                  if (statusObj) {
                    dataZero.statusObj = statusObj;
                  }
                }
                if (dataZero && dataZero.predictionResult !== null) {
                  newData.open = true;
                  newData.predicted = true;
                  this.hasModelResult = true;
                }
              });
              this.predictedResult = data;
              this.predicting = false;
              this.predicted = true;
            })
            .catch(() => {
              // console.log(e);
              this.predictedResult = [];
              this.predicting = false;
            });
          Promise.all(ruleBaseArr)
            .then((data) => {
              // Find result and set open ...
              data.forEach((res) => {
                const newRes = res;
                newRes.open = false;
                if (res.data && res.data.length > 0) {
                  newRes.open = true;
                  newRes.matched = true;
                  this.hasRuleResult = true;
                }
              });
              this.matchedResult = data;
              this.predicting = false;
              this.predicted = true;
            })
            .catch(() => {
              // console.log(e);
              this.matchedResult = [];
              this.predicting = false;
            });
        })
        .catch(() => {
          this.predicting = false;
          this.statusResult = [];
        });
    },
    toggleResult(data) {
      Vue.set(data, 'open', !data.open);
    },
    toPercentString(prop) {
      const pc = (+prop * 100).toFixed(0);
      return `${pc}%`;
    },
    getWidthStyle(prop) {
      return {
        width: this.toPercentString(prop),
      };
    },
    addToLearningList() {
      const text = this.messageInput.trim();
      this.createIssue({ text })
        .then(() => {
          this.$buefy.toast.open({
            type: 'is-success',
            message: 'Issue added.',
            position: 'is-bottom',
            duration: 3000,
          });
          this.messageInput = '';
          this.predictedResult = [];
          this.matchedResult = [];
          this.hasModelResult = false;
          this.hasRuleResult = false;
          this.predicting = false;
          this.predicted = false;
          this.$emit('added');
        })
        .catch(() => {
          // console.log(e.response);
        });
    },
  },
  computed: {
    ...mapGetters({}),
    modelIDList() {
      return this.modelList.map((item) => item.id);
    },
    modelNameIDMap() {
      const obj = {};
      this.modelList.forEach((model) => {
        obj[model.id] = model.name;
      });
      return obj;
    },
    ruleSetIdList() {
      return this.ruleSet.map((set) => set.id);
    },
    ruleSetNameIDMap() {
      const obj = {};
      this.ruleSet.forEach((set) => {
        obj[set.id] = set.name;
      });
      return obj;
    },
    isNotUnderstand() {
      if (this.predictedResult.length > 0 && this.matchedResult.length > 0) {
        return !(this.hasModelResult || this.hasRuleResult);
      } if (this.predicting) {
        return false;
      }
      return false;
    },
  },
};
</script>

<style lang="scss" scoped>
.understanding-block {
  display: flex;
  overflow: hidden;
  background-color: #fff;
  border: 1px solid #ddd;
  flex: 0 1 25%;
  min-width: 240px;
  margin-left: 1rem;
  display: flex;
  flex-direction: column;
  .title-bar {
    padding: 1rem;
    font-size: 0.8rem;
    border-bottom: 1px solid #ddd;
  }
  .input-bar {
    padding: 1rem;
    border-bottom: 1px solid #ddd;
  }
  .content-wrapper {
    background-color: #fafafa;
    .loading-card {
      padding: 1rem;
      .fas {
        margin-right: 10px;
      }
    }
    .result-model-card,
    .result-rulebase-card {
      padding: 1rem;
      border-bottom: 1px solid #ddd;
      display: inline-block;
      width: 100%;
      user-select: none;
      background-color: #fff;
      cursor: pointer;
      &:hover {
        background-color: #fcfcfc;
      }
    }
    .result-card-title {
      font-size: 0.8rem;
      display: flex;
      justify-content: space-between;
      .result-found-icon {
        font-size: 0.8rem;
        margin-left: 5px;
        color: #4caf4f;
      }
    }
    .result-block-data {
      .result-block-data-row {
        padding: 0.75rem 0 0 0;
        .category-name {
          color: #888;
          font-size: 0.8rem;
        }
        .button-space {
          min-width: 105px;
          padding-top: 4px;
          .button {
            min-width: 95px;
          }
        }
        .progress-block {
          position: relative;
          .progress-text {
            z-index: 10;
            min-width: 20px;
            position: absolute;
            text-align: center;
            color: #fff;
            line-height: 0.8rem;
            font-size: 0.6rem;
          }
          .progress {
            height: 10px;
            border-radius: 3px;
          }
        }
      }
    }
    .result-block-rule {
      display: flex;
      padding: 0.75rem 0 0 0;
      justify-content: space-between;
    }
    .not-understand-card {
      padding: 1rem;
      text-align: center;
      background-color: #fff;
      img {
        width: 100%;
        height: auto;
      }
    }
  }
}
</style>>
